import { render, staticRenderFns } from "./TaxsetNew.vue?vue&type=template&id=4d7998a2"
import script from "./TaxsetNew.vue?vue&type=script&lang=js"
export * from "./TaxsetNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports